import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import './CounselModal.css';

export function CounselModal({ offer, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  if (!offer) return null;

  return (
    <div className="counsel-modal" role="dialog" aria-modal="true" aria-labelledby="counsel-modal-title">
      <button type="button" className="counsel-modal__scrim" aria-label="Close" onClick={onClose} />
      <div className="counsel-modal__panel">
        <button type="button" className="counsel-modal__close" onClick={onClose} aria-label="Close">
          <X size={18} strokeWidth={1.5} />
        </button>

        <h2 id="counsel-modal-title" className="counsel-modal__title">
          {offer.title}
        </h2>
        <p className="counsel-modal__blurb">{offer.blurb}</p>

        <div className="counsel-modal__scope">
          <div>
            <p className="counsel-modal__scope-label">In scope</p>
            <ul>
              {offer.inScope.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <p className="counsel-modal__scope-label">Out of scope</p>
            <ul>
              {offer.outOfScope.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="counsel-modal__start">
          <p className="counsel-modal__scope-label">How we start</p>
          <p className="counsel-modal__start-body">{offer.howStart}</p>
        </div>

        <div className="counsel-modal__actions">
          <Link
            to={`/contact?interest=${offer.slug}`}
            className="counsel-modal__cta"
            onClick={onClose}
          >
            Let&apos;s Talk
          </Link>
        </div>
      </div>
    </div>
  );
}
